$(document).ready(function(){
  $(document).on('click','#categories-cls li.nav--has-dropdown span.arrow', function (){
    if($(this).parent('li').hasClass('liactive')== false ){
      $('ul#categories-cls li.nav--has-dropdown span.arrow').removeClass('active').siblings('ul').slideUp().parent('li').removeClass('liactive');
      $(this).addClass('active').siblings('ul').slideDown().parent('li').addClass('liactive');
    }else{
      $('ul#categories-cls li.nav--has-dropdown span.arrow').removeClass('active').siblings('ul').slideUp().parent('li').removeClass('liactive');
    }

  });

  $('input.current_acctive').click(function(){
    $('input.current_acctive').removeClass('border-active');
$(this).addClass('border-active'); 
});
    $('input.size_current_acctive').click(function(){
    $('input.size_current_acctive').removeClass('size_border-active');
$(this).addClass('size_border-active'); 
});




  
});